import { hashAny } from "math";
import type { RenderLinesProps } from "./types";

export const getLineRenderUID = (props: RenderLinesProps): string => {
  const colors = props.range.colors || [];
  const min = props.range.min || 0;
  const max = props.range.max || 0;
  const count = props.range.ranges ? props.range.ranges.length : 0;
  return hashAny([colors, min, max, count]);
}
